export const OOS_ROOT = '/oos';
/** Strategies compared over the labelled camera-days. */
export const OOS_DASHBOARD_PATH = `${OOS_ROOT}/dashboard`;
/** Snapshotted camera-days, and those with PR shadow results waiting for a snapshot. */
export const OOS_CAMERA_DAYS_PATH = `${OOS_ROOT}/camera-days`;
export const OOS_STRATEGIES_PATH = `${OOS_ROOT}/strategies`;

export type OosCameraDayView = 'timelines' | 'images';

/** One camera-day in its labelling view. */
export const oosCameraDayPath = (cameraDayId: string, view: OosCameraDayView = 'timelines') =>
  `${OOS_CAMERA_DAYS_PATH}/${encodeURIComponent(cameraDayId)}/${view}`;
